import "./Footer.scss";

export default function Footer() {
  return (
    <footer>
      <div className="container">
        <div className="row">
          <div className="col-md-6 text-center text-md-start">
            <p>Todos los derechos reservados 2021 JPF Estudio Fotografico</p>
          </div>
          <div className="col-md-6 text-center text-md-end">
            <p>Desarrollado por GUX</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
